import { css } from '@emotion/react';
import { useTheme, Typography } from '@mui/material';
import { MUIAvatar } from '../../Avatar/MUIAvatar';

type Props = {
  name: string;
  logoUrl: string;
};

const containerCss = css`
  display: flex;
  align-items: center;
`;

const logoWrapperCss = css`
  margin-right: 10px;
  margin-top: 2px;
  place-items: center;
  min-height: 24px;
  min-width: 24px;
`;

export const CompanyAndLogo = ({ name, logoUrl }: Props) => {
  const theme = useTheme();
  return (
    <div css={containerCss}>
      <div css={logoWrapperCss}>
        <MUIAvatar nameParts={name?.split(' ') ?? []} src={logoUrl} size='small' title={name} />
      </div>
      <Typography variant='caption' color={theme.colors.primary[100]} noWrap>
        {name}
      </Typography>
    </div>
  );
};
